import { FC, ReactNode } from 'react';

import { cn } from '@eluve/components';

const variantStyles = {
  default: 'bg-bg-primary',
  subtle: 'bg-bg-tertiary',
} as const;

const paddingStyles: Record<number, string> = {
  2: 'p-2',
  3: 'p-3',
  4: 'p-4',
  6: 'p-6',
  8: 'p-8',
};

const roundedStyles = {
  lg: 'rounded-lg',
  xl: 'rounded-xl',
} as const;

const gapStyles: Record<number, string> = {
  2: 'gap-2',
  3: 'gap-3',
  4: 'gap-4',
  6: 'gap-6',
  8: 'gap-8',
};

const alignStyles = {
  start: 'items-start',
  center: 'items-center',
  end: 'items-end',
  stretch: 'items-stretch',
} as const;

export interface CardRendererProps {
  variant?: 'default' | 'subtle';
  padding?: number;
  rounded?: 'lg' | 'xl';
  direction?: 'row' | 'column';
  gap?: number;
  align?: 'start' | 'center' | 'end' | 'stretch';
  children?: ReactNode;
}

export const CardRenderer: FC<CardRendererProps> = ({
  variant = 'default',
  padding = 6,
  rounded = 'xl',
  direction,
  gap,
  align,
  children,
}) => (
  <div
    className={cn(
      'w-full',
      variantStyles[variant],
      paddingStyles[padding] ?? 'p-6',
      roundedStyles[rounded],
      direction || gap || align ? 'flex' : undefined,
      direction === 'row'
        ? 'flex-row'
        : direction === 'column'
          ? 'flex-col'
          : undefined,
      gap != null ? gapStyles[gap] : undefined,
      align ? alignStyles[align] : undefined,
    )}
  >
    {children}
  </div>
);
